// extracted by mini-css-extract-plugin
module.exports = {"skeletonCard":"Skeleton_skeletonCard__zVa08","image":"Skeleton_image__hxMWa"};